<template>
  <filter-summary
    icon="item"
    title="商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>対象：{{ baseCount }}{{ baseLabel }}</div>
    <div>比較：{{ compareCount }}{{ compareLabel }}</div>
    <!-- <div>比較：{{ compareCount }}{{ compareLabel }}</div> -->
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,

    base: {
      type: Object,
      default: () => ({
        selectMode: 'category',
        categories: [],
        items: [],
        itemGroupId: undefined,
      }),
    },
    compare: {
      type: Object,
      default: () => ({
        selectMode: 'category',
        categories: [],
        items: [],
        itemGroupId: undefined,
      }),
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    baseCount() {
      return this.count(this.base)
    },
    baseLabel() {
      return this.label(this.base)
    },
    compareCount() {
      return this.count(this.compare)
    },
    compareLabel() {
      return this.label(this.compare)
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
  methods: {
    count(item) {
      if (item.selectMode === 'category') {
        return item.categories.length
      } else if (item.selectMode === 'item') {
        if (item.itemGroupId) {
          return undefined
        } else {
          return item.items.length
        }
      }
      return undefined
    },
    label(item) {
      if (item.selectMode === 'category') {
        return '分類'
      } else if (item.selectMode === 'item') {
        if (item.itemGroupId) {
          return '選択商品'
        } else {
          return '商品(商品指定)'
        }
      }
      return undefined
    },
  },
}
</script>
